import React, { useContext, useCallback, useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { FaChevronLeft } from 'react-icons/fa'
import urls from '../../../../utils/constants/urls'
import { useLocation } from 'react-router-dom'

import { DataContext } from '../DataContext'

export default () => {
    const { returnToList, submissionState, isReview, viewOnly } =
        useContext(DataContext)
    const location = useLocation()
    const { state: locationState } = location
    const history = useHistory()

    const onClick = useCallback(() => {
        returnToList()
            .then(() => {
                history.push({
                    pathname: urls.manageSampleResults,
                    state: {
                        from:
                            isReview || viewOnly
                                ? (locationState && locationState.from) ||
                                  'submitted'
                                : 'inProgress',
                    },
                })
            })
            .catch(() => {})
    }, [returnToList, locationState])

    const stationCode = useMemo(() => {
        if (
            submissionState &&
            submissionState.facility &&
            submissionState.facility.agencyFacilityCode
        ) {
            return submissionState.facility.agencyFacilityCode
        }
        if (location.state && location.state.stationCode) {
            return location.state.stationCode
        }
        return ''
    }, [submissionState, location])

    return (
        <nav
            className="breadcrumb breadcrumbAlignment"
            aria-label="breadcrumbs"
        >
            <ul>
                <li>
                    <div className="link" onClick={onClick}>
                        <span className="icon is-small">
                            <FaChevronLeft />
                        </span>
                        <span>Return to Submissions List</span>
                    </div>
                    <div className="clearinghouseNumber">
                        {submissionState && submissionState.uploadId && (
                            <p>
                                <b>Station Code:</b> {stationCode}
                            </p>
                        )}
                    </div>
                </li>
            </ul>
        </nav>
    )
}
